import { DarkModeManager } from "../../Common/DarkMode/DarkModeManager";
import { Application } from "../Application";
import { Bootstrapper } from "../Bootstrapper";

declare module "../ApplicationAliases" {
    interface ApplicationAliases {
        DarkModeManager: DarkModeManager;
    }
}

export class DarkModeBootstrapper extends Bootstrapper {
    /**
     * @inheritDoc
     */
    public bootstrap(): MaybePromise<void> {
        Application.bind("DarkModeManager", new DarkModeManager());
    }
}
